import constants from "../constants";

export const getCountryName = (countryCode) => {
    const addressCountry = constants.countries
        ? constants.countries.find(
              (country) => country.code === countryCode
          )
        : null;
    return addressCountry ? addressCountry.name : countryCode;
};

export const getCountryStates = (countryCode) => {
    const addressCountry = constants.countries
        ? constants.countries.find(
              (country) => country.code === countryCode
          )
        : null;
    return addressCountry ? addressCountry.countryStates : {};
};

export const getCountryVatNumberPrefix = (countryCode) => {
    const addressCountry = constants.countries
        ? constants.countries.find(
              (country) => country.code === countryCode
          )
        : null;
    return addressCountry ? addressCountry.vatNumberPrefix : '';
};

export const isSalesTaxCountry = (countryCode) => {
    return constants.countries.some(country => country.code === countryCode && country.isSalesTaxCountry)
}